<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>Many individuals’ lives unseen and untold, I would like to dedicate this book to my friend Sandra and people known and unknown to me. They inspired me to write and put my energy telling their stories; indeed, they were part of the nuances of us great and small.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?6ea8edac